// @flow
import React, { Component } from 'react';
import { CommonActions } from 'store/actionCreators';
import MainMobileHead from 'components/main/MainMobileHead';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { State } from 'store';
import { type ContextRouter, withRouter } from 'react-router-dom';
import { type CategoryData } from 'store/modules/common';

type Props = {
  categories: ?(CategoryData[]),
} & ContextRouter;

class MainMobileHeadContainer extends Component<Props> {
  initialize = () => {
    const { shouldCancel, categories } = this.props;
    if (categories && categories.length > 0) {
      // do not fetch categories data when already exists
      return;
    }
    try {
      if (!shouldCancel) {
        CommonActions.getCategories();
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const { categories } = this.props;
    return categories ? <MainMobileHead categories={categories} /> : <MainMobileHead />;
  }
}

export default compose(
  withRouter,
  connect(
    ({ common }: State) => ({
      categories: common.categories.data,
      shouldCancel: common.ssr && !common.router.altered,
    }),
    () => ({}),
  ),
)(MainMobileHeadContainer);



// WEBPACK FOOTER //
// ./src/containers/main/MainMobileHeadContainer.js